import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Time({ symbol_id }) {
  const socket = useContext(SocketContext);

  const [time, setTime] = useState(null);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.Timestamp !== undefined) {
        setTime(data.Timestamp);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return <div className="menuLtt addFlex small">{time ?? "—"}</div>;
}
